import { Loader2 } from "@baton/icons";
import { cva } from "class-variance-authority";
import { cn } from "../../../cn.ts";

/**
 * § Primitives, Spinner, taken from Spectrum UI's Spinner (`@spectrumui/spinner-dependencies`,
 * Apache-2.0) and themed through the variables of `packages/tokens`: the Loader2 arc on
 * `animate-spin` in `text-primary`. The loop runs on the motion token, so reduced motion stops
 * it. Indeterminate only and never the sole content indicator (FR-015-090); the label is its
 * accessible name. Spectrum UI's 24, 32 and 48 px sizes are a standalone page loader's; the
 * sizes here are the icon sizes of § Component sizes, because the spinner stands in for a
 * 16 px start icon inside a button, and a caller inside a filled control passes
 * `text-current`.
 */
const loaderVariants = cva("animate-spin text-primary", {
  variants: {
    size: {
      sm: "size-4",
      md: "size-5",
      lg: "size-6",
    },
  },
  defaultVariants: {
    size: "sm",
  },
});

export interface SpinnerProps {
  readonly size?: "sm" | "md" | "lg";
  readonly label: string;
  readonly className?: string;
}

export function Spinner({ size = "sm", label, className }: SpinnerProps) {
  return (
    <span role="status" aria-label={label} data-slot="spinner" className="inline-flex shrink-0">
      <Loader2 aria-hidden="true" className={cn(loaderVariants({ size }), className)} />
    </span>
  );
}
